export default {"src":"/_next/static/media/Vendor-Finance.9d35571f.svg","height":30,"width":30};